
import Award from "../../../assets/duotone/Award.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AwardIcon({ className, dataTestid = "AwardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Award data-testid={dataTestid} className={classes} {...rest} />
  );
}
